// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"NominateAmbassador_contentWrapper__3ABYy","title":"NominateAmbassador_title__2mdnY","formSection":"NominateAmbassador_formSection__1h9Sg"};